export const _LOAD_MODEL_ = 'Load:Banner';
export const _SAVE_MODEL_ = 'Save:Banner';
export const _DELETE_BANNER_ = 'Delete:Banner';

export const MODEL = {
  id: null,
  url: null,
  name: null,
  slug: null,
  order: 0,
  image: '',
  image_id: null,
  status_id: null,
  status: {
    name: 'Rascunho',
    slug: 'draft',
  },
  published_date: null,
};
